(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    var start = function () { api.initNriInquiry(document); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  }
})(this, function () {
  'use strict';

  function normalizePhone(value) {
    var raw = String(value || '').trim();
    if (!raw) return '';
    var digits = raw.replace(/\D/g, '');
    if (raw.charAt(0) !== '+' && /^[6-9]\d{9}$/.test(digits)) return '+91' + digits;
    if (raw.charAt(0) !== '+') return '';
    var normalized = '+' + digits;
    return /^\+[1-9]\d{6,14}$/.test(normalized) ? normalized : '';
  }

  function initNriInquiry(doc) {
    var form = doc.getElementById('RightWorkNriInquiryForm');
    if (!form || form.getAttribute('data-rwnri-ready') === 'true') return;
    form.setAttribute('data-rwnri-ready', 'true');

    var phone = form.querySelector('input[name="contact[phone]"]');
    var servicesHidden = form.querySelector('input[name="contact[Services Required]"]');
    var summary = form.querySelector('input[name="contact[body]"]');
    var serviceChecks = Array.prototype.slice.call(form.querySelectorAll('[data-rwnri-service]'));
    var serviceError = form.querySelector('[data-rwnri-service-error]');
    var phoneError = form.querySelector('[data-rwnri-phone-error]');
    var submit = form.querySelector('[data-rwnri-submit]');

    function selectedServices() {
      return serviceChecks.filter(function (item) { return item.checked; }).map(function (item) { return item.value; });
    }

    function syncServices() {
      var values = selectedServices();
      if (servicesHidden) servicesHidden.value = values.join(', ');
      if (serviceError) serviceError.hidden = values.length > 0;
      return values;
    }

    function validatePhone() {
      var normalized = normalizePhone(phone && phone.value);
      if (phoneError) phoneError.hidden = normalized !== '';
      if (phone) phone.setAttribute('aria-invalid', normalized ? 'false' : 'true');
      return normalized;
    }

    function value(name) {
      var field = form.querySelector('[name="' + name.replace(/"/g, '\\"') + '"]');
      return field ? String(field.value || '').trim() : '';
    }

    function buildSummary(normalizedPhone) {
      var lines = [
        'NRI HOME INTERIOR INQUIRY',
        '',
        'Name: ' + value('contact[name]'),
        'Email: ' + value('contact[email]'),
        'Phone: ' + normalizedPhone,
        'Country of Residence: ' + value('contact[Country of Residence]'),
        'Project Region: ' + value('contact[Project Region]'),
        'Project Location: ' + value('contact[Project Location]'),
        'Property Goal: ' + value('contact[Property Goal]'),
        'Property Type: ' + value('contact[Property Type]'),
        'Possession Timeline: ' + value('contact[Possession Timeline]')
      ];
      var startDate = value('contact[Expected Start Date]');
      if (startDate) lines.push('Expected Start Date: ' + startDate);
      lines.push('Budget: ' + value('contact[Budget Range]'));
      lines.push('Services: ' + value('contact[Services Required]'));
      var message = value('contact[Additional Message]');
      if (message) lines.push('Message: ' + message);
      lines.push('Lead Source: NRI Home Interiors - Bangalore & Hyderabad');
      return lines.join('\n');
    }

    serviceChecks.forEach(function (item) { item.addEventListener('change', syncServices); });
    if (phone) {
      phone.addEventListener('blur', validatePhone);
      phone.addEventListener('input', function () {
        if (phone.getAttribute('aria-invalid') === 'true') validatePhone();
      });
    }

    form.addEventListener('submit', function (event) {
      var services = syncServices();
      var normalizedPhone = validatePhone();
      if (!normalizedPhone || services.length === 0 || !form.checkValidity()) {
        event.preventDefault();
        if (services.length === 0 && serviceChecks[0]) serviceChecks[0].focus();
        else if (!normalizedPhone && phone) phone.focus();
        else if (typeof form.reportValidity === 'function') form.reportValidity();
        return;
      }

      phone.value = normalizedPhone;
      if (summary) summary.value = buildSummary(normalizedPhone);
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Submitting...';
      }
    });

    syncServices();
  }

  return { normalizePhone: normalizePhone, initNriInquiry: initNriInquiry };
});
